import { T } from 'components/Translations';
import { ApiUrl, AppPages } from 'project/Defines.js';
import { Project } from 'project/Project';
import { dispatchCustomEvent, EVENT_NAME } from 'project/utilities';
import React, { useCallback } from 'react';
import { useParams } from 'react-router-dom';
import DetailView from 'Shared/DetailView';
import Translation from 'Shared/Translation';
import useDetail from 'Shared/useDetail';



/**
 * Parameter detail of setup
 * @exports Setup-ParameterDetails
 */
export default function ParameterDetails(props) {
    const { id } = useParams();
    const { windowKey, data } = props;
    const listUpdateEvent = EVENT_NAME.SETUP_PRODUCT_PARAMETER_LIST_UPDATE;

    const { isNew, dataItem, setDataItem, updateData, closePopup, onDetailDelete, detailRef } = useDetail({
        data: data || { ID: id !== "create" ? id : null },
        updateUrl: ApiUrl.ParameterUpdate,
        windowKey,
        dataLoadUrl: ApiUrl.ParameterLoad,
        nameField: 'nom',
        deleteUrl: ApiUrl.ParameterDelete,
        backPage: AppPages.SetupProductParameter,
        listUpdateEvent,
        detailUrl: Project.getPageUrl(AppPages.SetupProductParameterDetails)
    });
    const updateSuccessCallback = useCallback((response) => {
        if (detailRef.current) {
            setDataItem(response);
        }

        dispatchCustomEvent(listUpdateEvent, { action: 'update' });
        dispatchCustomEvent(EVENT_NAME.SETUP_PRODUCT_PARAMETER_TRANSLATION_UPDATE, { ID: response.ID });
        closePopup();
    }, [setDataItem, closePopup, detailRef, listUpdateEvent]);

    return (<>
        {dataItem && <DetailView
            backUrl={Project.getPageUrl(AppPages.SetupProductParameter)}
            title={isNew ? <T>text.create_new_parameter</T> : dataItem.nom}
        >
            <form>
                <div className='form_container'>
                    <Translation
                        ID={dataItem.ID}
                        fields={['libelle']}
                        _class='App\Models\Catalogue\Parametre'
                        updateEvent={EVENT_NAME.SETUP_PRODUCT_PARAMETER_TRANSLATION_UPDATE}
                        updateCallback={() => { setDataItem({ ...dataItem, reloadData: true }); }} // NOSONAR
                    />
                </div>
                <toolbar>
                    <wrap>
                        <action right=''>
                            <div onClick={(e) => updateData(updateSuccessCallback)} className='button'><icon>save</icon><T>text.save</T></div>
                            {dataItem.ID &&
                                <div className='button' onClick={(e) => {
                                    onDetailDelete(dataItem)
                                }}>
                                <icon>delete</icon><T>text.delete</T>
                                </div>}
                        </action>
                    </wrap>
                </toolbar>
            </form>
        </DetailView>}
    </>);
}

